<template>
  <div class="form-group esma_form_group">
    <label  v-if="showLabel" v-bind:for="fieldID"
    :class="{'col-xs-4':true, 'control-label':true, 'esma_form_label':true,'esma_error_field':showAsError}"
    >{{fieldLabel}}  <span v-if="isRequired" class="is_required" aria-hidden="true">＊</span></label>
    <div :class="fieldClass" style="padding:1px 0px 1px 7px;">
      <datepicker
       :disabled-picker="isDisabled"
       :input-style="disabledStyle +';height: 24px!important;'+ filedStyle"
       :input-button-style="buttonStyle"
      input-class=" form-control force-white"
      v-on:input="updateValue"
      :id="fieldID"
      :name="fieldID"
      :value="fieldValue"
      :controller="dp_controller"
      placeholder=""
      calendar-style="left:-100px;"
      ></datepicker>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
//import Datepicker from 'vuejs-datepicker';
//https://github.com/charliekassel/vuejs-datepicker
import Datepicker from '../dp/Datepicker';

import { bus } from "@/libs/bus";
Vue.component('datepicker', Datepicker);
import debug from 'debug';
import moment from 'moment';
var debug_date_box = debug('esma:date_box');
export default {
  data() {
    return {
      count: 0,
      local_refresh_sequecnce: 1,
      show_as_error:false,
      cache_for_disable_and_clean_if_value:false,
      local_disabled:false,
      dp_controller:{ref_field:null}
    };
  },
  computed: {
    localDisabled:{
        get(){
          return this.local_disabled;
        },
        set(v){
          this.local_disabled = v;
        }
      },
    showAsError:{
      get(){
        return this.show_as_error;
      },
      set(v){
        this.show_as_error = v;
      }
    },
    localRefreshSequecnce:{
      get(){
        return this.local_refresh_sequecnce;
      },
      set(v){
        this.local_refresh_sequecnce = v;
      }
    },
    filedStyle() {
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row","current_field_style")][this.fieldID] || "";
      return (this.$props.data.field_style || "") + store_style;
    },
    stateCurrentRow(){
      if(typeof this.$props.data.state_current_row != "undefined"){
        return this.$props.data.state_current_row;
      }else{
        return "current_row";
      }
    },
    stateCurrentEditing(){
      if(typeof this.$props.data.state_current_editing != "undefined"){
        return this.$props.data.state_current_editing;
      }else{
        return "current_editing";
      }
    },
    stateIsEditingNew(){
      if(typeof this.$props.data.state_is_editing_new != "undefined"){
        return this.$props.data.state_is_editing_new;
      }else{
        return "is_editing_new";
      }
    },
    seqId() {
      return this.$props.data.seq_id;
    },
    bootstrapStylingTrue() {
      return true;
    },
    fieldLabel() {
      return this.$props.data.label;
    },
    isRequired(){
        return this.$props.data.error_if_blank || this.$props.data.error_if_blank || false;
    },
    fieldClass() {
      if (this.getOption('hide_label', false) == true) {
        return 'col-xs-12';
      } else {
        return 'col-xs-8';
      }
    },
    showLabel() {
      if (this.getOption('hide_label', false) == true) {
        return false;
      } else {
        return true;
      }
    },
    fieldValue() {
      debug_date_box('fieldValue');

      if (this.$store.state[this.stateCurrentRow][this.fieldID] == null) {
        this.count++;
        if (this.count > 2000) {
          this.count = 0;
        }
        debug_date_box('fieldValue return 1');
        return 3000 + this.count + '-01-01';
      } else {
        debug_date_box('fieldValue return 2 ', this.$store.state[this.stateCurrentRow][this.fieldID]);
        return (this.localRefreshSequecnce > 0) ? this.$store.state[this.stateCurrentRow][this.fieldID] : "";
      }
    },
    fieldID() {
      return this.$props.data.id;
    },
    fieldTableName() {
      return this.$props.data.table_name;
    },
    disabledStyle() {
      if (this.$store.state[this.stateIsEditingNew] == true) {
        return this.localDisabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined' ? 'background-color: #cccccc;' : 'background-color: white;';
      }
      return this.localDisabled || this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined' ? 'background-color: #cccccc;' : 'background-color: white;';
    },
    buttonStyle() {
      if (this.$store.state[this.stateIsEditingNew] == true) {
        debug_date_box('buttonStyle is_editing_new', typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined');
        return;
        typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined' ? 'background-color: #cccccc;' : 'background-color: white;';
      }
      debug_date_box('buttonStyle ', this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined');
      return this.localDisabled  || this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined' ? 'background-color: #cccccc;' : 'background-color: white;';
    },
    isDisabled() {
      debug_date_box("isDisabled");
      if (this.$store.state[this.stateIsEditingNew] == true) {
        return this.localDisabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined'; //TODO, can also has another field to force it.
      }
      var ret = this.localDisabled || this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined';
      if(ret){
        if(this.dp_controller && this.dp_controller.ref_field){
          this.dp_controller.ref_field.setValue(this.$store.state[this.stateCurrentRow][this.fieldID])
        }
      }
      return ret;
    }
  },
  methods: {
    updateValue(d) {
      // if(this.fieldTableName =="tab1"){
      debug_date_box('SET DATE', this.fieldID, d, this.$props.value);
      if (d == null) {
        this.$store.state[this.stateCurrentEditing][this.fieldID] = null;
      } else {
        this.$store.state[this.stateCurrentEditing][this.fieldID] =  moment(d).format("YYYY-MM-DD");
      }
    },
    getOption(name, def) {
      if (typeof this.$props.option[name] == 'undefined') {
        return def;
      }
      return this.$props.option[name];
    },
     onReceiveEvents(e, data) {
      if(e.mode == "disable_if_value"){
        if(e.disable_if_value == data.val){
          this.localDisabled = false;
        }else{
          this.localDisabled = true;
        }
      }else if(e.mode == "disable_and_clean_if_value"){
        if(e.disable_if_value == data.val){
          if(this.localDisabled != false){
            this.$store.state[this.stateCurrentRow][this.fieldID]= this.cache_for_disable_and_clean_if_value||"";
            this.$store.state[this.stateCurrentEditing][this.fieldID]= this.cache_for_disable_and_clean_if_value||"";
          }
          this.localDisabled = false;
        }else{
          if(this.localDisabled != true){
            this.cache_for_disable_and_clean_if_value = this.$store.state[this.stateCurrentEditing][this.fieldID] || this.$store.state[this.stateCurrentRow][this.fieldID]||this.$props.data.default||"";
          }
          this.localDisabled = true;
          this.$store.state[this.stateCurrentRow][this.fieldID]= this.$props.data.default||"";
          this.$store.state[this.stateCurrentEditing][this.fieldID]= this.$props.data.default||"";
        }
      }
    },
  },
  mounted() {

    if (typeof this.$props.data.listen_for != "undefined" && this.$props.data.listen_for.length > 0) {
      this.listen_for = this.$props.data.listen_for;
      this.listen_for.forEach(e => {
        // debug_select("mounted set listen_for ",e)
        bus.$off(e.name).$on(e.name, data => {
          this.onReceiveEvents(e, data);
        });
      });
    }


    this.$props.data.ref_field = this;
    this.$props.data.on_field_messages = (vm,msg,cb) =>{
      if(msg && msg.msg_type == "error"){
        if(msg.show_as_error_mode == false && this.showAsError == false){
          return cb(false);
        }
        var local_val = _.clone(this.$store.state[this.stateCurrentEditing][this.fieldID]);
        if(typeof local_val == "undefined"){
          local_val = _.clone(this.$store.state[this.stateCurrentRow][this.fieldID]) || null;
        }
        if(msg.show_as_error_mode && msg.only_if_enabled == true && this.isDisabled == true){
          this.showAsError = false;
          this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
          this.updateValue(local_val);
          this.localRefreshSequecnce++;
          return cb(false);
        }
        this.showAsError = msg.show_as_error_mode || false;
        this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
        this.updateValue(local_val);
        this.localRefreshSequecnce++;
        return cb(true);
      }
    }
  },
  props: ['data', 'value', 'option', 'read'],
};
</script>
<style scoped>
.esma_error_field {
  color:red;
}
.is_required{
  color:red;
}
.form-control[readonly].force_white {
  background-color: white;
  opacity: 1;
}
.form-control[disabled],
fieldset[disabled] .form-control {
  background-color: white;
}
.form-control {
  color: black;
  height: 24px;
  height: 24px!important;
}
.form-control::selection {
  color: white;
  background: #575757;
}
</style>


// WEBPACK FOOTER //
// date-box.vue?70dcb659